import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import style from "./featured-icon.css?inline";
import "@/components/icon";

// prettier-ignore
export const sizes = [
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
] as const;

export type FeaturedIconSize = (typeof sizes)[number];

// prettier-ignore
export const themes = [
  "accent",
  "danger",
  "info",
  "neutral",
  "success",
  "warning",
] as const;

export type FeaturedIconTheme = (typeof themes)[number];

export const variants = [
  "circular-dark",
  "circular-light",
  "empty-state",
  "square-dark",
  "square-light",
  "square-modern",
] as const;

export type FeaturedIconVariant = (typeof variants)[number];

@customElement("eko-featured-icon")
class FeaturedIcon extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) icon: string = "";
  @property({ reflect: true }) size: FeaturedIconSize = "md";
  @property({ reflect: true }) theme: FeaturedIconTheme = "neutral";
  @property({ reflect: true }) variant: FeaturedIconVariant = "square-modern";

  render() {
    return html`<eko-icon
      class="eko-featured-icon__icon"
      name=${this.icon}
      part="icon"></eko-icon>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-featured-icon": FeaturedIcon;
  }
}

export default FeaturedIcon;
